{
  "spaces": [
    {
      "label": "Demographics",
      "axes": [
        {
          "label": "Age",
          "traits": [
            {
              "label": "Under 18",
              "attUri": "optionQuestionResponse/7078",
              "scoreUri": "apct/29516"
            },
            {
              "label": "18 - 24",
              "attUri": "optionQuestionResponse/7078",
              "scoreUri": "apct/29517"
            },
            {
              "label": "25 - 29",
              "attUri": "optionQuestionResponse/7078",
              "scoreUri": "apct/30024"
            },
            {
              "label": "30 - 34",
              "attUri": "optionQuestionResponse/7078",
              "scoreUri": "apct/30025"
            },
            {
              "label": "35 - 44",
              "attUri": "optionQuestionResponse/7078",
              "scoreUri": "apct/29520"
            },
            {
              "label": "45 - 54",
              "attUri": "optionQuestionResponse/7078",
              "scoreUri": "apct/29521"
            },
            {
              "label": "55 - 64",
              "attUri": "optionQuestionResponse/7078",
              "scoreUri": "apct/29522"
            },
            {
              "label": "65 or older",
              "attUri": "optionQuestionResponse/7078",
              "scoreUri": "apct/29523"
            }
          ]
        },
        {
          "label": "Education & Occupation",
          "traits": [
            {
              "label": "Less than high school",
              "attUri": "optionQuestionResponse/131788",
              "scoreUri": "apct/1302079"
            },
            {
              "label": "High school or GED",
              "attUri": "optionQuestionResponse/131788",
              "scoreUri": "apct/1302080"
            },
            {
              "label": "Some college, no degree",
              "attUri": "optionQuestionResponse/131788",
              "scoreUri": "apct/1302081"
            },
            {
              "label": "Associate degree",
              "attUri": "optionQuestionResponse/131788",
              "scoreUri": "apct/1302082"
            },
            {
              "label": "Bachelor's degree",
              "attUri": "optionQuestionResponse/131788",
              "scoreUri": "apct/1302083"
            },
            {
              "label": "Graduate or professional degree",
              "attUri": "optionQuestionResponse/131788",
              "scoreUri": "apct/1302084"
            }
          ]
        },
        {
          "label": "Gender",
          "traits": [
            {
              "label": "Male",
              "attUri": "optionQuestionResponse/484",
              "scoreUri": "apct/1536"
            },
            {
              "label": "Female",
              "attUri": "optionQuestionResponse/484",
              "scoreUri": "apct/1537"
            }
          ]
        },
        {
          "label": "Income",
          "traits": [
            {
              "label": "$0 - $29,999",
              "attUri": "optionQuestionResponse/625781",
              "scoreUri": "apct/3548614"
            },
            {
              "label": "$30,000 - $49,999",
              "attUri": "optionQuestionResponse/625781",
              "scoreUri": "apct/3548615"
            },
            {
              "label": "$50,000 - $74,999",
              "attUri": "optionQuestionResponse/625781",
              "scoreUri": "apct/3548616"
            },
            {
              "label": "$75,000 - $99,999",
              "attUri": "optionQuestionResponse/625781",
              "scoreUri": "apct/3548617"
            },
            {
              "label": "$100,000 - $149,999",
              "attUri": "optionQuestionResponse/625781",
              "scoreUri": "apct/3548618"
            },
            {
              "label": "$150,000 - $199,999",
              "attUri": "optionQuestionResponse/625781",
              "scoreUri": "apct/3548619"
            },
            {
              "label": "$200,000 - $299,999",
              "attUri": "optionQuestionResponse/625781",
              "scoreUri": "apct/3548620"
            },
            {
              "label": "$300,000 - $399,999",
              "attUri": "optionQuestionResponse/625781",
              "scoreUri": "apct/3548621"
            },
            {
              "label": "$400,000 or more",
              "attUri": "optionQuestionResponse/625781",
              "scoreUri": "apct/3548622"
            }
          ]
        },
        {
          "label": "Parental Status",
          "traits": [
            {
              "label": "Parent",
              "attUri": "optionQuestionResponse/503",
              "scoreUri": "apct/1591"
            },
            {
              "label": "Grandparent",
              "attUri": "optionQuestionResponse/503",
              "scoreUri": "apct/1592"
            },
            {
              "label": "Neither",
              "attUri": "optionQuestionResponse/503",
              "scoreUri": "apct/1593"
            }
          ]
        },
        {
          "label": "Race & Ethnicity",
          "traits": [
            {
              "label": "White",
              "attUri": "optionQuestionResponse/216281",
              "scoreUri": "apct/1731456"
            },
            {
              "label": "Black or African American",
              "attUri": "optionQuestionResponse/216282",
              "scoreUri": "apct/1731458"
            },
            {
              "label": "Hispanic or Latino",
              "attUri": "optionQuestionResponse/216283",
              "scoreUri": "apct/1731460"
            },
            {
              "label": "American Indian or Alaska Native",
              "attUri": "optionQuestionResponse/216284",
              "scoreUri": "apct/1731462"
            },
            {
              "label": "Asian",
              "attUri": "optionQuestionResponse/216286",
              "scoreUri": "apct/1731466"
            },
            {
              "label": "Native Hawaiian or Other Pacific Islander",
              "attUri": "optionQuestionResponse/216286",
              "scoreUri": "apct/1731467"
            },
            {
              "label": "Other",
              "attUri": "optionQuestionResponse/216287",
              "scoreUri": "apct/1731468"
            }
          ]
        },
        {
          "label": "Political Affiliation",
          "traits": [
            {
              "label": "Democrat",
              "attUri": "optionQuestionResponse/150201",
              "scoreUri": "sql/6776"
            },
            {
              "label": "Republican",
              "attUri": "optionQuestionResponse/150201",
              "scoreUri": "sql/6777"
            },
            {
              "label": "Independent",
              "attUri": "optionQuestionResponse/150201",
              "scoreUri": "apct/1464465"
            }
          ]
        }
      ]
    },
    {
      "label": "Location",
      "axes": [
        {
          "label": "Urbanicity",
          "traits": [
            {
              "label": "City",
              "attUri": "optionQuestionResponse/497",
              "scoreUri": "apct/1576"
            },
            {
              "label": "Suburbs",
              "attUri": "optionQuestionResponse/497",
              "scoreUri": "apct/1577"
            },
            {
              "label": "Rural Area",
              "attUri": "optionQuestionResponse/497",
              "scoreUri": "apct/1578"
            }
          ]
        },
        {
          "label": "States",
          "traits": [
            {
              "label": "Arizona",
              "attUri": "geography/USState",
              "scoreUri": "apct/AZ"
            },
            {
              "label": "California",
              "attUri": "geography/USState",
              "scoreUri": "apct/CA"
            },
            {
              "label": "Colorado",
              "attUri": "geography/USState",
              "scoreUri": "apct/CO"
            },
            {
              "label": "Florida",
              "attUri": "geography/USState",
              "scoreUri": "apct/FL"
            },
            {
              "label": "Georgia",
              "attUri": "geography/USState",
              "scoreUri": "apct/GA"
            },
            {
              "label": "Illinois",
              "attUri": "geography/USState",
              "scoreUri": "apct/IL"
            },
            {
              "label": "Massachusetts",
              "attUri": "geography/USState",
              "scoreUri": "apct/MA"
            },
            {
              "label": "Michigan",
              "attUri": "geography/USState",
              "scoreUri": "apct/MI"
            },
            {
              "label": "Minnesota",
              "attUri": "geography/USState",
              "scoreUri": "apct/MN"
            },
            {
              "label": "New York",
              "attUri": "geography/USState",
              "scoreUri": "apct/NY"
            },
            {
              "label": "Ohio",
              "attUri": "geography/USState",
              "scoreUri": "apct/OH"
            },
            {
              "label": "Pennsylvania",
              "attUri": "geography/USState",
              "scoreUri": "apct/PA"
            },
            {
              "label": "Texas",
              "attUri": "geography/USState",
              "scoreUri": "apct/TX"
            },
            {
              "label": "Washington",
              "attUri": "geography/USState",
              "scoreUri": "apct/WA"
            }
          ]
        },
        {
          "label": "Metros & Cities",
          "traits": [
            {
              "label": "Atlanta GA",
              "attUri": "geography/USMetroArea",
              "scoreUri": "apct/524"
            },
            {
              "label": "Boston MA-Manchester NH",
              "attUri": "geography/USMetroArea",
              "scoreUri": "apct/506"
            },
            {
              "label": "Chicago IL",
              "attUri": "geography/USMetroArea",
              "scoreUri": "apct/602"
            },
            {
              "label": "Cleveland-Akron (Canton) OH",
              "attUri": "geography/USMetroArea",
              "scoreUri": "apct/510"
            },
            {
              "label": "Dallas-Ft. Worth TX",
              "attUri": "geography/USMetroArea",
              "scoreUri": "apct/623"
            },
            {
              "label": "Denver CO",
              "attUri": "geography/USMetroArea",
              "scoreUri": "apct/751"
            },
            {
              "label": "Detroit MI",
              "attUri": "geography/USMetroArea",
              "scoreUri": "apct/505"
            },
            {
              "label": "Houston TX",
              "attUri": "geography/USMetroArea",
              "scoreUri": "apct/618"
            },
            {
              "label": "Los Angeles CA",
              "attUri": "geography/USMetroArea",
              "scoreUri": "apct/803"
            },
            {
              "label": "Miami-Ft. Lauderdale FL",
              "attUri": "geography/USMetroArea",
              "scoreUri": "apct/528"
            },
            {
              "label": "Minneapolis-St. Paul MN",
              "attUri": "geography/USMetroArea",
              "scoreUri": "apct/613"
            },
            {
              "label": "New York NY",
              "attUri": "geography/USMetroArea",
              "scoreUri": "apct/501"
            },
            {
              "label": "Orlando-Daytona Beach-Melbourne FL",
              "attUri": "geography/USMetroArea",
              "scoreUri": "apct/534"
            },
            {
              "label": "Philadelphia PA",
              "attUri": "geography/USMetroArea",
              "scoreUri": "apct/504"
            },
            {
              "label": "Phoenix AZ",
              "attUri": "geography/USMetroArea",
              "scoreUri": "apct/753"
            },
            {
              "label": "Pittsburgh PA",
              "attUri": "geography/USMetroArea",
              "scoreUri": "apct/508"
            },
            {
              "label": "Sacramento-Stockton-Modesto CA",
              "attUri": "geography/USMetroArea",
              "scoreUri": "apct/862"
            },
            {
              "label": "San Francisco-Oakland-San Jose CA",
              "attUri": "geography/USMetroArea",
              "scoreUri": "apct/807"
            },
            {
              "label": "Seattle-Tacoma WA",
              "attUri": "geography/USMetroArea",
              "scoreUri": "apct/819"
            },
            {
              "label": "Tampa-St. Petersburg (Sarasota) FL",
              "attUri": "geography/USMetroArea",
              "scoreUri": "apct/539"
            },
            {
              "label": "Washington DC (Hagerstown MD)",
              "attUri": "geography/USMetroArea",
              "scoreUri": "apct/511"
            }
          ]
        }
      ]
    },
    {
      "label": "Brand Favorability",
      "axes": [
        {
          "label": "Auto",
          "traits": [
            {
              "label": "Acura",
              "attUri": "optionQuestionResponse/4956",
              "scoreUri": "brand/fav-eff"
            },
            {
              "label": "Audi",
              "attUri": "optionQuestionResponse/4957",
              "scoreUri": "brand/fav-eff"
            },
            {
              "label": "BMW",
              "attUri": "optionQuestionResponse/4958",
              "scoreUri": "brand/fav-eff"
            },
            {
              "label": "Buick",
              "attUri": "optionQuestionResponse/6331",
              "scoreUri": "brand/fav-eff"
            },
            {
              "label": "Cadillac",
              "attUri": "optionQuestionResponse/4960",
              "scoreUri": "brand/fav-eff"
            },
            {
              "label": "Chevrolet",
              "attUri": "optionQuestionResponse/6332",
              "scoreUri": "brand/fav-eff"
            },
            {
              "label": "Chrysler",
              "attUri": "optionQuestionResponse/6333",
              "scoreUri": "brand/fav-eff"
            },
            {
              "label": "Dodge",
              "attUri": "optionQuestionResponse/6334",
              "scoreUri": "brand/fav-eff"
            },
            {
              "label": "Ford",
              "attUri": "optionQuestionResponse/6335",
              "scoreUri": "brand/fav-eff"
            },
            {
              "label": "Honda",
              "attUri": "optionQuestionResponse/6337",
              "scoreUri": "brand/fav-eff"
            },
            {
              "label": "Hyundai",
              "attUri": "optionQuestionResponse/6338",
              "scoreUri": "brand/fav-eff"
            },
            {
              "label": "Infiniti",
              "attUri": "optionQuestionResponse/4969",
              "scoreUri": "brand/fav-eff"
            },
            {
              "label": "Jeep",
              "attUri": "optionQuestionResponse/6339",
              "scoreUri": "brand/fav-eff"
            },
            {
              "label": "Kia",
              "attUri": "optionQuestionResponse/6340",
              "scoreUri": "brand/fav-eff"
            },
            {
              "label": "Land Rover",
              "attUri": "optionQuestionResponse/4972",
              "scoreUri": "brand/fav-eff"
            },
            {
              "label": "Lexus",
              "attUri": "optionQuestionResponse/4973",
              "scoreUri": "brand/fav-eff"
            },
            {
              "label": "Lincoln",
              "attUri": "optionQuestionResponse/6341",
              "scoreUri": "brand/fav-eff"
            },
            {
              "label": "Mercedes",
              "attUri": "optionQuestionResponse/4975",
              "scoreUri": "brand/fav-eff"
            },
            {
              "label": "Mini",
              "attUri": "optionQuestionResponse/6343",
              "scoreUri": "brand/fav-eff"
            },
            {
              "label": "Mitsubishi",
              "attUri": "optionQuestionResponse/6344",
              "scoreUri": "brand/fav-eff"
            },
            {
              "label": "Nissan",
              "attUri": "optionQuestionResponse/6345",
              "scoreUri": "brand/fav-eff"
            },
            {
              "label": "Porsche",
              "attUri": "optionQuestionResponse/4979",
              "scoreUri": "brand/fav-eff"
            },
            {
              "label": "Saab",
              "attUri": "optionQuestionResponse/6346",
              "scoreUri": "brand/fav-eff"
            },
            {
              "label": "Subaru",
              "attUri": "optionQuestionResponse/12196",
              "scoreUri": "brand/fav-eff"
            },
            {
              "label": "Tesla",
              "attUri": "optionQuestionResponse/32355",
              "scoreUri": "brand/fav-eff"
            },
            {
              "label": "Toyota",
              "attUri": "optionQuestionResponse/6348",
              "scoreUri": "brand/fav-eff"
            },
            {
              "label": "Volkswagen",
              "attUri": "optionQuestionResponse/6349",
              "scoreUri": "brand/fav-eff"
            },
            {
              "label": "Volvo",
              "attUri": "optionQuestionResponse/6350",
              "scoreUri": "brand/fav-eff"
            }
          ]
        },
        {
          "label": "Retail",
          "traits": [
            {
              "label": "Abercrombie and Fitch",
              "attUri": "optionQuestionResponse/6368",
              "scoreUri": "brand/fav-eff"
            },
            {
              "label": "Aeropostale",
              "attUri": "optionQuestionResponse/6370",
              "scoreUri": "brand/fav-eff"
            },
            {
              "label": "American Apparel",
              "attUri": "optionQuestionResponse/6371",
              "scoreUri": "brand/fav-eff"
            },
            {
              "label": "American Eagle Outfitters",
              "attUri": "optionQuestionResponse/6372",
              "scoreUri": "brand/fav-eff"
            },
            {
              "label": "Banana Republic",
              "attUri": "optionQuestionResponse/6373",
              "scoreUri": "brand/fav-eff"
            },
            {
              "label": "Bloomingdales",
              "attUri": "optionQuestionResponse/6356",
              "scoreUri": "brand/fav-eff"
            },
            {
              "label": "Costco",
              "attUri": "optionQuestionResponse/6362",
              "scoreUri": "brand/fav-eff"
            },
            {
              "label": "Express",
              "attUri": "optionQuestionResponse/6378",
              "scoreUri": "brand/fav-eff"
            },
            {
              "label": "GAP",
              "attUri": "optionQuestionResponse/6381",
              "scoreUri": "brand/fav-eff"
            },
            {
              "label": "H&M",
              "attUri": "optionQuestionResponse/6383",
              "scoreUri": "brand/fav-eff"
            },
            {
              "label": "Hollister & Co.",
              "attUri": "optionQuestionResponse/6384",
              "scoreUri": "brand/fav-eff"
            },
            {
              "label": "Hot Topic",
              "attUri": "optionQuestionResponse/6385",
              "scoreUri": "brand/fav-eff"
            },
            {
              "label": "J. Crew",
              "attUri": "optionQuestionResponse/6386",
              "scoreUri": "brand/fav-eff"
            },
            {
              "label": "JCPenney",
              "attUri": "optionQuestionResponse/6351",
              "scoreUri": "brand/fav-eff"
            },
            {
              "label": "Kmart",
              "attUri": "optionQuestionResponse/6358",
              "scoreUri": "brand/fav-eff"
            },
            {
              "label": "Kohl's",
              "attUri": "optionQuestionResponse/6352",
              "scoreUri": "brand/fav-eff"
            },
            {
              "label": "L.L. Bean",
              "attUri": "optionQuestionResponse/6389",
              "scoreUri": "brand/fav-eff"
            },
            {
              "label": "Macy's",
              "attUri": "optionQuestionResponse/6353",
              "scoreUri": "brand/fav-eff"
            },
            {
              "label": "Marshalls",
              "attUri": "optionQuestionResponse/6365",
              "scoreUri": "brand/fav-eff"
            },
            {
              "label": "Nordstrom",
              "attUri": "optionQuestionResponse/6354",
              "scoreUri": "brand/fav-eff"
            },
            {
              "label": "Nordstrom Rack",
              "attUri": "optionQuestionResponse/6366",
              "scoreUri": "brand/fav-eff"
            },
            {
              "label": "Old Navy",
              "attUri": "optionQuestionResponse/6393",
              "scoreUri": "brand/fav-eff"
            },
            {
              "label": "Ross",
              "attUri": "optionQuestionResponse/6364",
              "scoreUri": "brand/fav-eff"
            },
            {
              "label": "Saks Fifth Avenue",
              "attUri": "optionQuestionResponse/6357",
              "scoreUri": "brand/fav-eff"
            },
            {
              "label": "Sears",
              "attUri": "optionQuestionResponse/6355",
              "scoreUri": "brand/fav-eff"
            },
            {
              "label": "Target",
              "attUri": "optionQuestionResponse/6359",
              "scoreUri": "brand/fav-eff"
            },
            {
              "label": "TJ Maxx",
              "attUri": "optionQuestionResponse/6363",
              "scoreUri": "brand/fav-eff"
            },
            {
              "label": "Urban Outfitters",
              "attUri": "optionQuestionResponse/6400",
              "scoreUri": "brand/fav-eff"
            },
            {
              "label": "Victoria's Secret",
              "attUri": "optionQuestionResponse/6401",
              "scoreUri": "brand/fav-eff"
            },
            {
              "label": "Walmart",
              "attUri": "optionQuestionResponse/6360",
              "scoreUri": "brand/fav-eff"
            }
          ]
        },
        {
          "label": "Restaurants",
          "traits": [
            {
              "label": "Applebee's",
              "attUri": "optionQuestionResponse/6558",
              "scoreUri": "brand/fav-eff"
            },
            {
              "label": "Arby's",
              "attUri": "optionQuestionResponse/6559",
              "scoreUri": "brand/fav-eff"
            },
            {
              "label": "Atlanta Bread Company",
              "attUri": "optionQuestionResponse/6560",
              "scoreUri": "brand/fav-eff"
            },
            {
              "label": "Au Bon Pain",
              "attUri": "optionQuestionResponse/6561",
              "scoreUri": "brand/fav-eff"
            },
            {
              "label": "Bahama Breeze Island Grille",
              "attUri": "optionQuestionResponse/30064",
              "scoreUri": "brand/fav-eff"
            },
            {
              "label": "Baja Fresh",
              "attUri": "optionQuestionResponse/6562",
              "scoreUri": "brand/fav-eff"
            },
            {
              "label": "Baskin Robbins",
              "attUri": "optionQuestionResponse/6563",
              "scoreUri": "brand/fav-eff"
            },
            {
              "label": "Bob Evans Restaurants",
              "attUri": "optionQuestionResponse/6564",
              "scoreUri": "brand/fav-eff"
            },
            {
              "label": "Boston Market",
              "attUri": "optionQuestionResponse/6565",
              "scoreUri": "brand/fav-eff"
            },
            {
              "label": "Bruegger's",
              "attUri": "optionQuestionResponse/6566",
              "scoreUri": "brand/fav-eff"
            },
            {
              "label": "Buca di Beppo",
              "attUri": "optionQuestionResponse/6567",
              "scoreUri": "brand/fav-eff"
            },
            {
              "label": "Buffalo Wild Wings",
              "attUri": "optionQuestionResponse/24756",
              "scoreUri": "brand/fav-eff"
            },
            {
              "label": "Burger King",
              "attUri": "optionQuestionResponse/6568",
              "scoreUri": "brand/fav-eff"
            },
            {
              "label": "California Pizza Kitchen",
              "attUri": "optionQuestionResponse/6569",
              "scoreUri": "brand/fav-eff"
            },
            {
              "label": "The Capital Grille",
              "attUri": "optionQuestionResponse/30066",
              "scoreUri": "brand/fav-eff"
            },
            {
              "label": "Champps Americana",
              "attUri": "optionQuestionResponse/6571",
              "scoreUri": "brand/fav-eff"
            },
            {
              "label": "Charley's Grilled Subs",
              "attUri": "optionQuestionResponse/6572",
              "scoreUri": "brand/fav-eff"
            },
            {
              "label": "Cheesecake Factory",
              "attUri": "optionQuestionResponse/6573",
              "scoreUri": "brand/fav-eff"
            },
            {
              "label": "Chili's",
              "attUri": "optionQuestionResponse/6574",
              "scoreUri": "brand/fav-eff"
            },
            {
              "label": "Chipotle",
              "attUri": "optionQuestionResponse/6575",
              "scoreUri": "brand/fav-eff"
            },
            {
              "label": "Cosi",
              "attUri": "optionQuestionResponse/6576",
              "scoreUri": "brand/fav-eff"
            },
            {
              "label": "Cracker Barrel Old Country Store",
              "attUri": "optionQuestionResponse/6577",
              "scoreUri": "brand/fav-eff"
            },
            {
              "label": "Culver's",
              "attUri": "optionQuestionResponse/6578",
              "scoreUri": "brand/fav-eff"
            },
            {
              "label": "Denny's",
              "attUri": "optionQuestionResponse/6580",
              "scoreUri": "brand/fav-eff"
            },
            {
              "label": "Domino's",
              "attUri": "optionQuestionResponse/6581",
              "scoreUri": "brand/fav-eff"
            },
            {
              "label": "Dunkin Donuts",
              "attUri": "optionQuestionResponse/6582",
              "scoreUri": "brand/fav-eff"
            },
            {
              "label": "Einstein Bros. Bagels",
              "attUri": "optionQuestionResponse/6583",
              "scoreUri": "brand/fav-eff"
            },
            {
              "label": "El Pollo Loco",
              "attUri": "optionQuestionResponse/6584",
              "scoreUri": "brand/fav-eff"
            },
            {
              "label": "Five Guys Burgers and Fries",
              "attUri": "optionQuestionResponse/7068",
              "scoreUri": "brand/fav-eff"
            },
            {
              "label": "Fuddruckers",
              "attUri": "optionQuestionResponse/6585",
              "scoreUri": "brand/fav-eff"
            },
            {
              "label": "Hard Rock",
              "attUri": "optionQuestionResponse/6586",
              "scoreUri": "brand/fav-eff"
            },
            {
              "label": "Hardee's/Carl's Jr.",
              "attUri": "optionQuestionResponse/6587",
              "scoreUri": "brand/fav-eff"
            },
            {
              "label": "Houlihan's",
              "attUri": "optionQuestionResponse/6588",
              "scoreUri": "brand/fav-eff"
            },
            {
              "label": "IHOP",
              "attUri": "optionQuestionResponse/6589",
              "scoreUri": "brand/fav-eff"
            },
            {
              "label": "In-N-Out Burger",
              "attUri": "optionQuestionResponse/7070",
              "scoreUri": "brand/fav-eff"
            },
            {
              "label": "Jack in the Box",
              "attUri": "optionQuestionResponse/6590",
              "scoreUri": "brand/fav-eff"
            },
            {
              "label": "Jersey Mikes",
              "attUri": "optionQuestionResponse/24858",
              "scoreUri": "brand/fav-eff"
            },
            {
              "label": "Jimmy John's",
              "attUri": "optionQuestionResponse/6591",
              "scoreUri": "brand/fav-eff"
            },
            {
              "label": "Joe's Crab Shack",
              "attUri": "optionQuestionResponse/6592",
              "scoreUri": "brand/fav-eff"
            },
            {
              "label": "KFC",
              "attUri": "optionQuestionResponse/6593",
              "scoreUri": "brand/fav-eff"
            },
            {
              "label": "Little Caesar's",
              "attUri": "optionQuestionResponse/6594",
              "scoreUri": "brand/fav-eff"
            },
            {
              "label": "Logan's Roadhouse",
              "attUri": "optionQuestionResponse/6595",
              "scoreUri": "brand/fav-eff"
            },
            {
              "label": "Lone Star Steakhouse & Saloon",
              "attUri": "optionQuestionResponse/6596",
              "scoreUri": "brand/fav-eff"
            },
            {
              "label": "LongHorn Steakhouse",
              "attUri": "optionQuestionResponse/30059",
              "scoreUri": "brand/fav-eff"
            },
            {
              "label": "Long John Silver's",
              "attUri": "optionQuestionResponse/6597",
              "scoreUri": "brand/fav-eff"
            },
            {
              "label": "McDonald's",
              "attUri": "optionQuestionResponse/6598",
              "scoreUri": "brand/fav-eff"
            },
            {
              "label": "Mimi's",
              "attUri": "optionQuestionResponse/6599",
              "scoreUri": "brand/fav-eff"
            },
            {
              "label": "Moe's Southwest Grill",
              "attUri": "optionQuestionResponse/6600",
              "scoreUri": "brand/fav-eff"
            },
            {
              "label": "Noodles & Company",
              "attUri": "optionQuestionResponse/6601",
              "scoreUri": "brand/fav-eff"
            },
            {
              "label": "O'Charley's",
              "attUri": "optionQuestionResponse/6602",
              "scoreUri": "brand/fav-eff"
            },
            {
              "label": "Olive Garden",
              "attUri": "optionQuestionResponse/6603",
              "scoreUri": "brand/fav-eff"
            },
            {
              "label": "On the Border",
              "attUri": "optionQuestionResponse/6604",
              "scoreUri": "brand/fav-eff"
            },
            {
              "label": "The Original Pancake House",
              "attUri": "optionQuestionResponse/6631",
              "scoreUri": "brand/fav-eff"
            },
            {
              "label": "Outback Steakhouse",
              "attUri": "optionQuestionResponse/6605",
              "scoreUri": "brand/fav-eff"
            },
            {
              "label": "P.F. Chang's China Bistro",
              "attUri": "optionQuestionResponse/6606",
              "scoreUri": "brand/fav-eff"
            },
            {
              "label": "Panchero's",
              "attUri": "optionQuestionResponse/6824",
              "scoreUri": "brand/fav-eff"
            },
            {
              "label": "Panera",
              "attUri": "optionQuestionResponse/6607",
              "scoreUri": "brand/fav-eff"
            },
            {
              "label": "Papa John's",
              "attUri": "optionQuestionResponse/6608",
              "scoreUri": "brand/fav-eff"
            },
            {
              "label": "Perkins Restaurant and Bakery",
              "attUri": "optionQuestionResponse/6609",
              "scoreUri": "brand/fav-eff"
            },
            {
              "label": "Pizza Hut",
              "attUri": "optionQuestionResponse/6610",
              "scoreUri": "brand/fav-eff"
            },
            {
              "label": "Ponderosa Steakhouse",
              "attUri": "optionQuestionResponse/6611",
              "scoreUri": "brand/fav-eff"
            },
            {
              "label": "Popeye's Chicken",
              "attUri": "optionQuestionResponse/6612",
              "scoreUri": "brand/fav-eff"
            },
            {
              "label": "Potbelly",
              "attUri": "optionQuestionResponse/6613",
              "scoreUri": "brand/fav-eff"
            },
            {
              "label": "Qdoba Mexican Grill",
              "attUri": "optionQuestionResponse/6614",
              "scoreUri": "brand/fav-eff"
            },
            {
              "label": "Quizno's",
              "attUri": "optionQuestionResponse/6615",
              "scoreUri": "brand/fav-eff"
            },
            {
              "label": "Red Lobster",
              "attUri": "optionQuestionResponse/6616",
              "scoreUri": "brand/fav-eff"
            },
            {
              "label": "Red Robin",
              "attUri": "optionQuestionResponse/6617",
              "scoreUri": "brand/fav-eff"
            },
            {
              "label": "Romano's Macaroni Grill",
              "attUri": "optionQuestionResponse/6618",
              "scoreUri": "brand/fav-eff"
            },
            {
              "label": "Rubio's",
              "attUri": "optionQuestionResponse/6825",
              "scoreUri": "brand/fav-eff"
            },
            {
              "label": "Ruby Tuesday",
              "attUri": "optionQuestionResponse/6619",
              "scoreUri": "brand/fav-eff"
            },
            {
              "label": "Salsarita's",
              "attUri": "optionQuestionResponse/6826",
              "scoreUri": "brand/fav-eff"
            },
            {
              "label": "Sbarro",
              "attUri": "optionQuestionResponse/6620",
              "scoreUri": "brand/fav-eff"
            },
            {
              "label": "Schlotzsky's",
              "attUri": "optionQuestionResponse/6621",
              "scoreUri": "brand/fav-eff"
            },
            {
              "label": "Seasons 52",
              "attUri": "optionQuestionResponse/30065",
              "scoreUri": "brand/fav-eff"
            },
            {
              "label": "Shoney's",
              "attUri": "optionQuestionResponse/6622",
              "scoreUri": "brand/fav-eff"
            },
            {
              "label": "Sizzler",
              "attUri": "optionQuestionResponse/6623",
              "scoreUri": "brand/fav-eff"
            },
            {
              "label": "SONIC",
              "attUri": "optionQuestionResponse/6624",
              "scoreUri": "brand/fav-eff"
            },
            {
              "label": "Steak 'n Shake",
              "attUri": "optionQuestionResponse/6626",
              "scoreUri": "brand/fav-eff"
            },
            {
              "label": "Subway",
              "attUri": "optionQuestionResponse/6627",
              "scoreUri": "brand/fav-eff"
            },
            {
              "label": "T.G.I. Friday's",
              "attUri": "optionQuestionResponse/6628",
              "scoreUri": "brand/fav-eff"
            },
            {
              "label": "Taco Bell",
              "attUri": "optionQuestionResponse/6629",
              "scoreUri": "brand/fav-eff"
            },
            {
              "label": "Texas Roadhouse",
              "attUri": "optionQuestionResponse/6630",
              "scoreUri": "brand/fav-eff"
            },
            {
              "label": "Tony Roma's",
              "attUri": "optionQuestionResponse/6632",
              "scoreUri": "brand/fav-eff"
            },
            {
              "label": "Uno Chicago Grill",
              "attUri": "optionQuestionResponse/6633",
              "scoreUri": "brand/fav-eff"
            },
            {
              "label": "Wendy's",
              "attUri": "optionQuestionResponse/6634",
              "scoreUri": "brand/fav-eff"
            },
            {
              "label": "Whataburger",
              "attUri": "optionQuestionResponse/7069",
              "scoreUri": "brand/fav-eff"
            }
          ]
        }
      ]
    },
    {
      "label": "Interest",
      "axes": [
        {
          "label": "Interest",
          "traits": [
            {
              "label": "Automotive",
              "attUri": "multiscore",
              "scoreUri": "7721"
            },
            {
              "label": "Economy",
              "attUri": "multiscore",
              "scoreUri": "7724"
            },
            {
              "label": "Food & Drink",
              "attUri": "multiscore",
              "scoreUri": "7720"
            },
            {
              "label": "News & Politics",
              "attUri": "multiscore",
              "scoreUri": "7723"
            },
            {
              "label": "Elections",
              "attUri": "multiscore",
              "scoreUri": "7718"
            },
            {
              "label": "Political Issues",
              "attUri": "multiscore",
              "scoreUri": "7722"
            },
            {
              "label": "Personal Finance",
              "attUri": "multiscore",
              "scoreUri": "7725"
            },
            {
              "label": "Real Estate",
              "attUri": "multiscore",
              "scoreUri": "7716"
            },
            {
              "label": "Sports",
              "attUri": "multiscore",
              "scoreUri": "7733"
            },
            {
              "label": "Television",
              "attUri": "multiscore",
              "scoreUri": "7734"
            },
            {
              "label": "Travel",
              "attUri": "multiscore",
              "scoreUri": "7717"
            },
            {
              "label": "Tech and Gadgets",
              "attUri": "multiscore",
              "scoreUri": "8006"
            },
            {
              "label": "Local & Independently Owned Restaurants",
              "attUri": "multiscore",
              "scoreUri": "8003"
            },
            {
              "label": "Home Improvement DIY",
              "attUri": "multiscore",
              "scoreUri": "8004"
            }
          ]
        }
      ]
    },
    {
      "label": "Purchase Intent",
      "axes": [
        {
          "label": "Intent",
          "traits": [
            {
              "label": "Arts & Entertainment",
              "attUri": "multiscore",
              "scoreUri": "7729"
            },
            {
              "label": "Automotive Ownership",
              "attUri": "multiscore",
              "scoreUri": "7731"
            },
            {
              "label": "Finance & Insurance",
              "attUri": "multiscore",
              "scoreUri": "7732"
            },
            {
              "label": "Home & Garden Services",
              "attUri": "multiscore",
              "scoreUri": "7730"
            },
            {
              "label": "Travel & Tourism",
              "attUri": "multiscore",
              "scoreUri": "7735"
            },
            {
              "label": "Tech and Gadgets",
              "attUri": "multiscore",
              "scoreUri": "8007"
            },
            {
              "label": "Clothing",
              "attUri": "multiscore",
              "scoreUri": "8017"
            },
            {
              "label": "Home Improvement",
              "attUri": "multiscore",
              "scoreUri": "8018"
            }
          ]
        }
      ]
    },
    {
      "label": "Consumption",
      "axes": [
        {
          "label": "Media Broadcasting Technology Users",
          "traits": [
            {
              "label": "Cable TV",
              "attUri": "optionQuestionResponse/101789",
              "scoreUri": "apct/1207000"
            },
            {
              "label": "Satellite",
              "attUri": "optionQuestionResponse/101789",
              "scoreUri": "apct/1207002"
            },
            {
              "label": "Telco- IPTV",
              "attUri": "optionQuestionResponse/101789",
              "scoreUri": "apct/1207001"
            },
            {
              "label": "Antenna",
              "attUri": "optionQuestionResponse/101789",
              "scoreUri": "apct/1207003"
            },
            {
              "label": "Video streaming (Netflix, Hulu, and Amazon Prime Video)",
              "attUri": "multiscore",
              "scoreUri": "7923"
            },
            {
              "label": "Live Web streaming (Twitch, YouTube Live, and Facebook Live)",
              "attUri": "multiscore",
              "scoreUri": "7924"
            }
          ]
        },
        {
          "label": "Television Networks",
          "traits": [
            {
              "label": "ABC",
              "attUri": "optionQuestionResponse/138617",
              "scoreUri": "apct/1424649"
            },
            {
              "label": "CBS",
              "attUri": "optionQuestionResponse/138617",
              "scoreUri": "apct/1424650"
            },
            {
              "label": "NBC",
              "attUri": "optionQuestionResponse/138617",
              "scoreUri": "apct/1424651"
            },
            {
              "label": "FOX (not fox news)",
              "attUri": "optionQuestionResponse/138617",
              "scoreUri": "apct/1424652"
            }
          ]
        },
        {
          "label": "Television Genres",
          "traits": [
            {
              "label": "Mystery / Suspense / Crime",
              "attUri": "optionQuestionResponse/377374",
              "scoreUri": "apct/2430707"
            },
            {
              "label": "Science Fiction / Fantasy",
              "attUri": "optionQuestionResponse/377375",
              "scoreUri": "apct/2430709"
            },
            {
              "label": "Sports",
              "attUri": "optionQuestionResponse/377376",
              "scoreUri": "apct/2430711"
            },
            {
              "label": "Lifestyle",
              "attUri": "optionQuestionResponse/377377",
              "scoreUri": "apct/2430713"
            },
            {
              "label": "Comedy",
              "attUri": "optionQuestionResponse/377378",
              "scoreUri": "apct/2430715"
            },
            {
              "label": "Entertainment / Celebrities / Music",
              "attUri": "optionQuestionResponse/377379",
              "scoreUri": "apct/2430717"
            },
            {
              "label": "Action / Adventure",
              "attUri": "optionQuestionResponse/377380",
              "scoreUri": "apct/2430719"
            }
          ]
        },
        {
          "label": "Search Engine",
          "traits": [
            {
              "label": "AOL",
              "attUri": "optionQuestionResponse/7031",
              "scoreUri": "apct/29324"
            },
            {
              "label": "Ask",
              "attUri": "optionQuestionResponse/7031",
              "scoreUri": "apct/29325"
            },
            {
              "label": "Bing",
              "attUri": "optionQuestionResponse/7031",
              "scoreUri": "apct/29326"
            },
            {
              "label": "Google",
              "attUri": "optionQuestionResponse/7031",
              "scoreUri": "apct/29327"
            },
            {
              "label": "Yahoo!",
              "attUri": "optionQuestionResponse/7031",
              "scoreUri": "apct/29330"
            }
          ]
        },
        {
          "label": "Phone Brand",
          "traits": [
            {
              "label": "Apple iPhone",
              "attUri": "optionQuestionResponse/146683",
              "scoreUri": "apct/1451455"
            },
            {
              "label": "Samsung Galaxy",
              "attUri": "optionQuestionResponse/146683",
              "scoreUri": "apct/1451456"
            },
            {
              "label": "Samsung Galaxy Note",
              "attUri": "optionQuestionResponse/146683",
              "scoreUri": "apct/1451457"
            },
            {
              "label": "Google Pixel",
              "attUri": "optionQuestionResponse/146683",
              "scoreUri": "apct/1451458"
            },
            {
              "label": "LG",
              "attUri": "optionQuestionResponse/146683",
              "scoreUri": "apct/1451459"
            }
          ]
        },
        {
          "label": "Operating System",
          "traits": [
            {
              "label": "Mac",
              "attUri": "optionQuestionResponse/1519",
              "scoreUri": "apct/5009"
            },
            {
              "label": "PC",
              "attUri": "optionQuestionResponse/1519",
              "scoreUri": "apct/5010"
            },
            {
              "label": "Both (Mac and PC)",
              "attUri": "optionQuestionResponse/1519",
              "scoreUri": "apct/28484"
            }
          ]
        }
      ]
    }
  ]
}
